import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import {AuthenticationService} from 'app/services/auth.service';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'VDPicker',
    templateUrl: './vd-picker.component.html',
    styleUrls: ['./vd-picker.component.scss'],
    imports: [FormsModule, DatePipe]
})

export class VDPickerComponent implements OnInit {
  private auth = inject(AuthenticationService);

  @Output() dateChange: EventEmitter<string>;
  public vd: null | string = null;
  public dates: null | string[] = null;

  constructor() {
    this.dateChange = new EventEmitter<string>();
  }

  ngOnInit(): void {
    this.auth.getAllValuationDates().subscribe(data => {
      this.dates = data;
      this.vd = this.auth.getCurrentValuationDate();
    });
  }

  onChange() {
    if (this.vd) {
      this.auth.setCurrentValuationDate(this.vd);
      this.dateChange.emit(this.vd);
    }
  }

}
